import React, { useCallback, useEffect, useMemo } from "react";
import { number } from "prop-types";
import { useRouter } from "next/router";
import Pagination from "@insightfulscience/atomic-react/Pagination";

const PagePagination = ({ total, current }) => {
	const router = useRouter();
	const max = 3;

	const config = useMemo(() => {
		let maxLinks = max + 1;
		let h = 1;
		if (current > maxLinks) {
			h = h + current - maxLinks;
		}

		if (current >= 1) {
			maxLinks = maxLinks + current - 1;
		}
		if (maxLinks > total) {
			maxLinks = total + 1;
		}
		return {
			start: h,
			end: maxLinks,
		};
	}, [max, current, total]);

	const changePage = useCallback(
		page => {
			const { page: currentPage, ...query } = router.query || {};

			if (page === 1) {
				router.push({
					pathname: router.pathname,
					query,
				});
			} else {
				router.push({
					pathname: router.pathname,
					query: { ...query, page },
				});
			}
		},
		[router],
	);

	useEffect(() => {
		if (+router.query?.page === 1) {
			const { page, ...query } = router.query;
			router.push({
				pathname: router.pathname,
				query,
			});
		}
	}, [router]);

	return total > 1 ? (
		<Pagination>
			{current > 1 ? (
				<Pagination.Item icon="left" onClick={() => changePage(current - 1)}>
					Previous
				</Pagination.Item>
			) : null}
			{new Array(config.end - config.start).fill().map((_, index) => {
				const page = config.start + index;
				return (
					<Pagination.Item
						key={`pagination_page_${page}`}
						active={page === current}
						onClick={() => changePage(page)}
					>
						{page}
					</Pagination.Item>
				);
			})}
			{current < total ? (
				<Pagination.Item icon="right" onClick={() => changePage(current + 1)}>
					Next
				</Pagination.Item>
			) : null}
		</Pagination>
	) : null;
};

PagePagination.propTypes = {
	total: number.isRequired,
	current: number.isRequired,
};

export default PagePagination;
